import { render, staticRenderFns } from "./FormatGroups.vue?vue&type=template&id=b70853fc&scoped=true&"
import script from "./FormatGroups.vue?vue&type=script&lang=ts&"
export * from "./FormatGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70853fc",
  null
  
)

export default component.exports